var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSh3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_816_78721)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4392 16.74C19.2449 16.9282 19.1557 17.2005 19.1999 17.4675L19.8667 21.1575C19.9229 21.4702 19.7909 21.7868 19.5292 21.9675C19.2727 22.155 18.9314 22.1775 18.6517 22.0275L15.3299 20.295C15.2144 20.2335 15.0862 20.2005 14.9549 20.1968H14.7517C14.6812 20.2073 14.6122 20.2297 14.5492 20.2642L11.2267 22.005C11.0624 22.0875 10.8764 22.1168 10.6942 22.0875C10.2502 22.0035 9.95391 21.5805 10.0267 21.1343L10.6942 17.4442C10.7384 17.175 10.6492 16.9012 10.4549 16.71L7.74666 14.085C7.52016 13.8652 7.44141 13.5353 7.54491 13.2375C7.64541 12.9405 7.90191 12.7238 8.21166 12.675L11.9392 12.1342C12.2227 12.105 12.4717 11.9325 12.5992 11.6775L14.2417 8.31C14.2807 8.235 14.3309 8.166 14.3917 8.1075L14.4592 8.055C14.4944 8.016 14.5349 7.98375 14.5799 7.9575L14.6617 7.9275L14.7892 7.875H15.1049C15.3869 7.90425 15.6352 8.073 15.7649 8.325L17.4292 11.6775C17.5492 11.9228 17.7824 12.093 18.0517 12.1342L21.7792 12.675C22.0942 12.72 22.3574 12.9375 22.4617 13.2375C22.5599 13.5383 22.4752 13.8682 22.2442 14.085L19.4392 16.74Z",
    fill: "url(#paint1_linear_816_78721)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_78721",
    x1: 0,
    y1: 0,
    x2: 30.599,
    y2: 0.813926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_816_78721",
    x1: 7.5,
    y1: 7.875,
    x2: 22.8003,
    y2: 8.30343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh3);
export default __webpack_public_path__ + "static/media/sh3.2796f228e49062d765a4bdedf664b5ed.svg";
export { ForwardRef as ReactComponent };